import axios from "./_axios";
import { API } from "./apiEndPoints";
import { updateAccountCounts } from "@/utils/accountCountUtils";
import qs from "qs";

export const getListofEmployeesV2 = async ({ account_id, queryParamsObj }) => {
  let result = await axios()({
    method: "get",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/employee/`,
    params: { ...queryParamsObj },
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: "repeat" });
    },
  });
  return result;
};

export const getEmployeeByIdV2 = async ({ account_id, employeeId }) => {
  let result = await axios()({
    method: "get",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/employee/${employeeId}/`,
    params: null,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: "repeat" });
    },
  });
  return result;
};

export const getListofEmployee = async (account_id, page_no, size) => {
  let result = await axios()({
    method: "get",
    url: `${API.ACCOUNTList}${account_id}/employee/`,
    params: { page: page_no, size: size },
  });
  return result;
};

export const getListofEmployeeV2 = async (
  account_id,
  limit,
  offset,
  searchQuery = ""
) => {
  const params = { limit: limit, offset: offset };

  // Add search parameter if provided
  if (searchQuery && searchQuery.trim() !== "") {
    params.name = searchQuery.trim();
  }

  let result = await axios()({
    method: "get",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/employee/`,
    params: params,
  });
  return result;
};

export const getSingleEmployeeV2 = async (account_id, employee_id) => {
  let result = await axios()({
    method: "get",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/employee/${employee_id}/`,
    params: "",
  });
  return result;
};

export const getListofEmployeeV1 = async (
  account_id,
  limit,
  offset,
  searchQuery = "",
  status = "active",
  ordering = "first_name",
  archived = false
) => {
  const params = { limit: limit, offset: offset };

  // Add search parameter if provided
  if (searchQuery && searchQuery.trim() !== "") {
    params.name = searchQuery.trim();
  }

  if (status) {
    params.status = status;
  }

  if (archived) {
    params.archived = archived;
  }

  if (ordering) {
    params.ordering = ordering;
  }

  let result = await axios()({
    method: "get",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/employee/`,
    params: params,
  });
  return result;
};

export const createEmployee = (account_id, data) => {
  let result = axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/employee/`,
    data: data,
  });
  return result;
};

export const activateEmployee = async (account_id, employee_id) => {
  let result = await axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/employee/${employee_id}/activate/`,
  });
  await updateAccountCounts(account_id);
  return result;
};

export const updateEmployee = (account_id, employee_id, data) => {
  let result = axios()({
    method: "put",
    url: `${API.ACCOUNTList}${account_id}/employee/${employee_id}/`,
    data: data,
  });
  return result;
};

export const employeeStateUpdate = (account_id, user_id, data) => {
  let result = axios()({
    method: "put",
    url: `${API.ACCOUNTList}${account_id}/employee/${user_id}/`,
    data: data,
  });
  return result;
};

export const terminateEmployee = async (account_id, user_id, payload) => {
  let result = await axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/employee/${user_id}/terminate/`,
    data: payload,
  });
  await updateAccountCounts(account_id);
  return result;
};

export const reactivateEmployee = async (account_id, employee_id) => {
  let result = await axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/employee/${employee_id}/reactivate/`,
  });
  await updateAccountCounts(account_id);
  return result;
};

export const deleteEmployee = (account_id, user_id) => {
  let result = axios()({
    method: "delete",
    url: `${API.ACCOUNTList}${account_id}/employee/${user_id}/`,
  });
  return result;
};

export const getEmployeeById = (account_id, emp_id) => {
  let result = axios()({
    method: "get",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/employee/${emp_id}/`,
  });
  return result;
};

export const getEmployeeInspectionData = (
  account_id,
  emp_id,
  responsibility_id
) => {
  let result = axios()({
    method: "get",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/employee/${emp_id}/`,
    params: {
      can_inspect: true,
      responsibility_id: responsibility_id,
    },
  });
  return result;
};

export const getAccountData = (account_id) => {
  let result = axios()({
    method: "get",
    url: `${API.ACCOUNTList}${account_id}/`,
  });
  return result;
};
export const updateEmployeeExcludeValue = (account_id, emp_id, data) => {
  let result = axios()({
    method: "patch",
    url: `${API.ACCOUNTList}${account_id}/employee/${emp_id}/`,
    data: data,
  });
  return result;
};

export const getEmployeeChatter = (account_id, emp_id, page = 1) => {
  let result = axios()({
    method: "get",
    url: `${API.RESPONSIBILITY}${account_id}/employee/${emp_id}/chatter/`,
    params: { page: page },
  });
  return result;
};
export const getEmployeeAssignment = (account_id, emp_id, val) => {
  let result = axios()({
    method: "get",
    url: `${API.ACCOUNTList}${account_id}/employee/${emp_id}/assignments/`,
    params: { path_to_readiness: val },
  });
  return result;
};
export const getEmployeeMasterResponsibilites = (
  account_id,
  limit = 10,
  offset = 0,
  searchQuery = "",
  archived = false,
  ordering = "name"
) => {
  const params = {
    mastered: "true",
    limit: limit,
    offset: offset,
    archived: archived,
    ordering: ordering,
  };

  // Add name parameter if provided
  if (searchQuery && searchQuery.trim() !== "") {
    params.name = searchQuery.trim();
  }

  // Note: Filters are now handled on the frontend, not sent to backend

  let result = axios()({
    method: "get",
    url: `${API.RESPONSIBILITY_V2}${account_id}/responsibility/`,
    params: params,
    paramsSerializer: (params) => {
      const parts = [];
      Object.keys(params).forEach((key) => {
        const value = params[key];
        if (Array.isArray(value)) {
          value.forEach((v) => {
            parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(v)}`);
          });
        } else if (value !== undefined && value !== null) {
          parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
        }
      });
      return parts.join("&");
    },
  });
  return result;
};
export const getEmployeeCoachResponsibilites = (account_id, emp_id) => {
  let result = axios()({
    method: "get",
    url: `${API.RESPONSIBILITY}${account_id}/employee/${emp_id}/employees-to-coach/`,
  });
  return result;
};
export const getEmployeeCoachResponsibilitesV2 = (
  account_id,
  limit = 10,
  offset = 0,
  searchQuery = "",
  archived = false,
  ordering = "name"
) => {
  const params = {
    can_coach: "True",
    limit: limit,
    offset: offset,
    archived: archived,
    ordering: ordering,
  };

  // Add name parameter if provided
  if (searchQuery && searchQuery.trim() !== "") {
    params.name = searchQuery.trim();
  }

  let result = axios()({
    method: "get",
    url: `${API.RESPONSIBILITY_V2}${account_id}/responsibility/`,
    params: params,
  });
  return result;
};
export const getDirectoryEmployees = (account_id) => {
  let result = axios()({
    method: "get",
    url: `${API.ACCOUNTList}${account_id}/employee/readiness-badges/`,
  });
  return result;
};
export const getDirectoryResponsibilities = (account_id) => {
  let result = axios()({
    method: "get",
    url: `${API.RESPONSIBILITY}${account_id}/responsibilities-directory/`,
  });
  return result;
};
export const getEmployeeBadgesList = (account_id, emp_id) => {
  let result = axios()({
    method: "get",
    url: `${API.ACCOUNTList}${account_id}/employee/employee-badges-detail/${emp_id}/`,
  });
  return result;
};

export const getEmployeeBadges = (account_id, emp_id) => {
  let result = axios()({
    method: "get",
    url: `${API.RESPONSIBILITY}${account_id}/employee/${emp_id}/badge/`,
  });
  return result;
};

export const removePositionAssignmentForEmployee = (
  account_id,
  assignment_id,
  data
) => {
  let result = axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/position-assignment/${assignment_id}/relieve/`,
    data: data,
  });
  return result;
};
export const archiveEmployee = async (account_id, empId) => {
  let result = await axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/employee/${empId}/archive/`,
  });
  await updateAccountCounts(account_id);
  return result;
};
export const unArchiveEmployee = async (account_id, empId) => {
  let result = await axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/employee/${empId}/unarchive/`,
  });
  await updateAccountCounts(account_id);
  return result;
};
export const recalculateEmployeeReadiness = (account_id, emp_id) => {
  let result = axios()({
    method: "get",
    url: `${API.RESPONSIBILITY}${account_id}/employee/${emp_id}/recalculate-readiness/`,
  });
  return result;
};

export const updateImportanceValue = (account_id, data) => {
  let result = axios()({
    method: "post",
    url: `${API.ACCOUNTList}${account_id}/assignment/change-importance/`,
    data: data,
  });
  return result;
};
export const updateEmployeeReadiness = (account_id, employee_id) => {
  let result = axios()({
    method: "get",
    url: `${API.RESPONSIBILITY}${account_id}/employee/${employee_id}/recalculate-readiness/`,
  });
  return result;
};
export const updateAllEmployeeReadiness = (account_id, employee_ids) => {
  let result = axios()({
    method: "post",
    url: `${API.RESPONSIBILITY}${account_id}/recalculate-all-readiness/`,
    data: employee_ids,
  });
  return result;
};
// ============================|V2 End points|============================//
export const getEmployeeAssignments = (
  account_id,
  employee_id,
  limit = 10,
  offset = 0,
  status = null,
  search = null
) => {
  let url = `${API.ACCOUNT_LIST_V2}${account_id}/position-assignment/?employee=${employee_id}&limit=${limit}&offset=${offset}`;

  // Handle multiple status filters
  if (status) {
    if (Array.isArray(status)) {
      status.forEach((s) => {
        url += `&status=${s}`;
      });
    } else {
      url += `&status=${status}`;
    }
  }

  // Handle search parameter
  if (search) {
    url += `&name=${encodeURIComponent(search)}`;
  }

  let result = axios()({
    method: "get",
    url: url,
  });
  return result;
};

export const getAuthUserResponsibilitiesAssignments = (
  account_id,
  employee_id,
  offset = 0,
  limit = 10,
  searchQuery = "",
  proficiencyLevels = []
) => {
  const params = {
    offset,
    limit,
    employee: employee_id,
    status: "active",
    ordering: "-rank",
  };

  // Add name parameter if provided
  if (searchQuery && searchQuery.trim() !== "") {
    params.name = searchQuery.trim();
  }

  // Add proficiency_level parameters (can be multiple for duplicate query params)
  if (proficiencyLevels && proficiencyLevels.length > 0) {
    params.proficiency_level = proficiencyLevels;
  }

  let result = axios()({
    method: "get",
    url: `${API.RESPONSIBILITY_V2}${account_id}/responsibility-assignment/`,
    params: params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: "repeat" });
    },
  });
  return result;
};

export const getAuthUserProficiencyLevel = async (account_id, emp_id) => {
  let result = await axios()({
    method: "get",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/employee/${emp_id}/proficiency/`,
  });
  return result;
};

export const getEmployeeEvaluation = async (
  account_id,
  responsibility_id,
  employee_id,
  offset = 0,
  limit = 10,
  queryParams = {}
) => {
  let result = await axios()({
    method: "get",
    url: `${API.PROFICIENCY_V2}${account_id}/evaluation/`,
    params: {
      responsibility: responsibility_id,
      employee: employee_id,
      offset: offset,
      limit: limit,
      ...queryParams,
    },
  });
  return result;
};

export const getEvaluationSummaryByLevel = async (
  account_id,
  responsibility_id,
  employee_id,
  queryParams = {}
) => {
  let result = await axios()({
    method: "get",
    url: `${API.PROFICIENCY_V2}${account_id}/evaluation/summary-by-level/`,
    params: {
      responsibility: responsibility_id,
      employee: employee_id,
      ...queryParams,
    },
  });
  return result;
};

export const getEmployeesToInspect = (
  account_id,
  limit = 10,
  offset = 0,
  searchQuery = "",
  archived = false,
  ordering = "name",
  badgeFilter = null
) => {
  const params = {
    can_inspect: "true",
    limit: limit,
    offset: offset,
    archived: archived,
    ordering: ordering,
  };

  // Add name parameter if provided
  if (searchQuery && searchQuery.trim() !== "") {
    params.name = searchQuery.trim();
  }

  // Add badge_filter parameter if provided
  if (badgeFilter && badgeFilter.length > 0) {
    params.badge_filter = badgeFilter.join(",");
  }

  let result = axios()({
    method: "get",
    url: `${API.ACCOUNT_LIST_V2}${account_id}/employee/`,
    params: params,
  });
  return result;
};
